"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@emotion/react");
var Box_1 = __importDefault(require("@mui/material/Box"));
var CssBaseline_1 = __importDefault(require("@mui/material/CssBaseline"));
var Grid_1 = __importDefault(require("@mui/material/Grid"));
var BravasIllustration_1 = __importDefault(require("../BravasIllustration"));
var logo_png_1 = __importDefault(require("./logo.png"));
function FullScreenLayout(_a) {
    var children = _a.children;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_1.Global, { styles: (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          #app-root {\n            min-height: 100vh;\n            padding: 0rem;\n            display: flex;\n            flex-direction: column;\n            font-size: 16px;\n          }\n        "], ["\n          #app-root {\n            min-height: 100vh;\n            padding: 0rem;\n            display: flex;\n            flex-direction: column;\n            font-size: 16px;\n          }\n        "]))) }), (0, jsx_runtime_1.jsx)(CssBaseline_1.default, {}), (0, jsx_runtime_1.jsxs)(Grid_1.default, __assign({ container: true, alignItems: "stretch", direction: "row", minHeight: "100vh", display: "flex" }, { children: [(0, jsx_runtime_1.jsx)(Grid_1.default, __assign({ item: true, xs: 12, lg: 6, justifyContent: "center", alignItems: "center", display: "flex" }, { children: (0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ display: "flex", justifyContent: "center", flexDirection: "column", alignContent: "center" }, { children: [(0, jsx_runtime_1.jsx)(Box_1.default, { sx: {
                                        ml: {
                                            xs: 5,
                                            xl: 5,
                                        },
                                        mt: {
                                            xs: 4,
                                            xl: 4,
                                        },
                                    }, position: "absolute", top: 0, component: "img", src: logo_png_1.default, width: "222px", height: "50px", alt: "Bravas" }), (0, jsx_runtime_1.jsx)(Box_1.default, __assign({ sx: {
                                        ml: {
                                            xs: 6,
                                            lg: 16,
                                            xl: 25,
                                        },
                                        mr: {
                                            xs: 6,
                                            lg: 16,
                                            xl: 25,
                                        },
                                        mt: 16,
                                        mb: 4,
                                        // maxWidth: '1500px',
                                    } }, { children: children }))] })) })), (0, jsx_runtime_1.jsx)(Grid_1.default, __assign({ item: true, lg: 6, sx: {
                            display: { md: 'none', lg: 'flex' },
                        }, justifyContent: "center", bgcolor: "secondary.dark" }, { children: (0, jsx_runtime_1.jsx)(BravasIllustration_1.default, {}) }))] }))] }));
}
exports.default = FullScreenLayout;
var templateObject_1;
//# sourceMappingURL=FullScreenLayout.js.map